import { NavLink } from "react-router-dom";
import "./bars.scss";
import { MdLogout } from "react-icons/md";
import { FcHome } from "react-icons/fc";
import AuthService from "../services/auth.service";
import { jwtDecode } from "jwt-decode";

import { Image } from "react-bootstrap";

export default function Sidebar() {
  const token = localStorage.getItem("user");
  const userRole = token ? jwtDecode(token).rol : null;
  const Name = token ? jwtDecode(token).nombre : null;

  const SPCTI = "SPCTI";
  const Administrador = "Administrador";
  const Junior = "Junior";
  const Senior = "Senior";
  
  //const URL = "https://sidec.veracruz.gob.mx:3000";
  const URL = "https://sidec.veracruz.gob.mx";

  const handleLogout = () => {
    AuthService.logout();
    localStorage.clear();
    window.location.href = "/login";
  };

  return (
    <div className="sidebar">
      <div className="w-100">
        <p className="nocolor minitext">&zwnj;</p>
        <Image
          src={`${URL}/logoSidebar.png`}
          fluid
          className="verticalalign pt-1"
        />
        <p className="text-center whitetext mediumtext">
          <strong>V1.0</strong>
        </p>
        <p className="text-center text-white fs-5">
          <strong>{userRole}</strong>
          <p>{Name}</p>
        </p>
      </div>

      <ul>
        <li>
          <NavLink
            to="/home"
            className="text-white rounded py-2 w-100 d-inline-block px-1 text-center"
          >
            <FcHome className="me-1" />
            Inicio
          </NavLink>
        </li>
        {userRole === SPCTI ? (
          <li>
            <strong className="gobtext">Usuarios:</strong>
            <NavLink
              to="/usuarios"
              className="text-white rounded py-2 w-100 d-inline-block px-1"
            >
              Lista
            </NavLink>
            <strong className="gobtext">Acciones:</strong>
              <NavLink
                to="/quejashome"
                className="text-white rounded py-2 w-100 d-inline-block px-1 text-center"
                disabled
              >
                <Image
                  src={`${URL}/icons/megafono.png`}
                  
                  fluid
                  height={30}
                  width={30}
                />
                Denuncias
              </NavLink>
              <br />
              <br />
              <NavLink
                to="/reporte"
                className="text-white rounded py-2 w-100 d-inline-block px-1 text-center"
              >
                <Image
                  src={`${URL}/icons/excel.png`}
                  fluid
                  height={30}
                  width={30}
                />{" "}
                {}
                Reporte
              </NavLink>
              <br />
              <br />
              {/* <a
                href="/registro"
                className="text-white rounded py-2 w-100 d-inline-block px-1 text-center linktext"
                target="_blank"
                rel="noreferrer"
              >
                <Image
                  src={`${URL}/icons/registro.png`}
                  fluid
                  height={30}
                  width={30}
                />
                <br />
                Formulario Denuncia
              </a> */}
          </li>
        ) : null}

        
        {userRole === Administrador | userRole === Senior ? (
          <li>
            <NavLink
              to="/quejashome"
              className="text-white rounded py-2 w-100 d-inline-block px-1 text-center"
              disabled
            >
              <Image
                src={`${URL}/icons/megafono.png`}
                fluid
                height={30}
                width={30}
              />
              Denuncias
            </NavLink>
            <br />
            <br />
            <NavLink
              to="/reporte"
              className="text-white rounded py-2 w-100 d-inline-block px-1 text-center"
            >
              <Image
                src={`${URL}/icons/excel.png`}
                fluid
                height={30}
                width={30}
              />{" "}
              {}
              Crear Reporte
            </NavLink>
            <br />
            <br />
            {/* <a
              href="/registro"
              className="text-white rounded py-2 w-100 d-inline-block px-1 text-center linktext"
              target="_blank"
              rel="noreferrer"
            >
              <Image
                src={`${URL}/icons/registro.png`}
                fluid
                height={30}
                width={30}
              />
              <br />
              Formulario Denuncia
            </a> */}
          </li>
        ) : null}

        {userRole === Junior  ? (
          <li>
            <NavLink
              to="/quejashome"
              className="text-white rounded py-2 w-100 d-inline-block px-1 text-center"
              disabled
            >
              <Image
                src={`${URL}/icons/megafono.png`}
                fluid
                height={30}
                width={30}
              />
              Denuncias
            </NavLink>
            <br />
            <br />
            <NavLink
              to="/reporte"
              className="text-white rounded py-2 w-100 d-inline-block px-1 text-center"
            >
              <Image
                src={`${URL}/icons/excel.png`}
                fluid
                height={30}
                width={30}
              />{" "}
              {}
              Crear Reporte
            </NavLink>
            <br />
            <br />
            {/* <a
              href="/registro"
              className="text-white rounded py-2 w-100 d-inline-block px-1 text-center linktext"
              target="_blank"
              rel="noreferrer"
            >
              <Image
                src={`${URL}/icons/registro.png`}
                fluid
                height={30}
                width={30}
              />
              <br />
              Formulario Denuncia
            </a> */}
          </li>
        ) : null}
        

        <li>
          <NavLink
            to="/login"
            className="text-white rounded py-2 w-100 d-inline-block px-1 text-center"
            onClick={handleLogout}
          >
            <MdLogout className="me-1" />
            Cerrar sesión
          </NavLink>
        </li>
      </ul>
    </div>
  );
}
